module.exports = __webpack_public_path__ + "static/media/pay-method-pic.70167444.png";